import React from 'react'
import './Phone.css'

export default function Phone() {
  return (
    <div className="phone border">
        <div className="phonetop">
            <hr className="hr"></hr>
        </div>
        <div className="phonemid">
            <img src="./img/Front.png" className="phonemid" alt="phone"/>

        </div>
        <div className="phonebottom" >
            <div className="circle">

            </div>
        </div>
    </div>
  )
}
